import { Divider, Link, MenuItem, MenuList } from '@mui/material';
import { CuriosityNamespace, CuriosityValue } from '@procureai/curiosity-ui-mui';
import { RestrictionCheck, useRestricted } from '@procureai/permissions-ui';
import { ElementType } from 'react';
import { useTranslation } from 'react-i18next';
import { LinkProps } from 'react-router-dom';
import { Union } from 'ts-toolbelt';

import { EncodedQuery, EncodedQueryProps } from '~/components/EncodedQuery/EncodedQuery';

interface ListCountCellMenuProps {
  list: Union.Nullable<{ id: string }[]>;
  ns: CuriosityNamespace;
  link?: {
    needs?: RestrictionCheck;
    all?: {
      label: string;
      pathname: string;
      rules: EncodedQueryProps['rules'];
    };
    to?: (id: string) => LinkProps['to'];
    component?: ElementType;
  };
}

export const CuriosityListCountCellMenu = ({ list, ns, link }: ListCountCellMenuProps) => {
  const { t } = useTranslation('translation');
  const isAllowed = useRestricted(link?.needs);

  return (
    <MenuList disablePadding>
      {link?.all && isAllowed && (
        <EncodedQuery pathname={link.all?.pathname} rules={link.all?.rules}>
          {/* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */}
          {(linkProps) => <MenuItem {...linkProps}>{t(link.all!.label)}</MenuItem>}
        </EncodedQuery>
      )}
      {link?.all && isAllowed && <Divider />}
      {list &&
        list.map((item: any, index: number) => {
          const linkProps = isAllowed &&
            link?.to && {
              component: link?.component ?? Link,
              to: link?.to(item.id),
            };
          return (
            <MenuItem key={index} {...linkProps}>
              <CuriosityValue ns={ns} i18nKey={item.id} />
            </MenuItem>
          );
        })}
    </MenuList>
  );
};
